/**
 * NO03 - Fakturakopi Saga Index
 */

import { takeLatest } from 'redux-saga/effects';
import * as actionTypes from '../actions/actionTypesNO03';
import * as sagas from './NO03.saga';

export function* watchNO03() {
  yield takeLatest(actionTypes.NO03_SEARCH_REQUEST, sagas.searchNO03InvoicesSaga);
  yield takeLatest(actionTypes.NO03_LOAD_FIRMA_LIST, sagas.loadNO03FirmaListSaga);
  yield takeLatest(actionTypes.NO03_LOAD_MORE_REQUEST, sagas.loadMoreNO03InvoicesSaga);
}
